import React, { useState } from "react";
import { colors } from "../../../themes/Colors";

const DotMarker = ({ selected, onClick }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        height: hover ? 15 : 10,
        width: hover ? 15 : 10,
        borderRadius: 50,
        backgroundColor: selected ? colors.white : colors.secondaryDarkBlue,
        transition: hover ? "all 0.2s" : "all 0.7s",
        WebkitBoxShadow: "0px 5px 5px 3px #00000090",
      }}
    ></div>
  );
};

export default DotMarker;
